import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to the top left of the screen instantly
    window.scrollTo(0, 0);
  }, [pathname]); // This triggers every time the route (pathname) changes

  return null; // This component doesn't render anything visually
}